<script>
import Recepty from "@/components/clients/Recepty.vue";

export default {
  name: "ReceptyDialog",
  components: {Recepty},
  props: ["visible","clientid","therapistid","visitid"],
  methods: {
    close() {
      this.$emit('close')
    },
  }
}
</script>

<template>
  <v-dialog v-model="visible" fullscreen persistent>
    <v-card>
      <v-toolbar dark class="primary">
        <v-btn icon @click.native="close()" dark>
          <v-icon>fa-times</v-icon>
        </v-btn>
        <v-toolbar-title>Recepty pacjenta</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <Recepty :clientid="clientid" :therapistid="therapistid" :visitid="visitid" v-if="visible"></Recepty>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>